<mat-expansion-panel class="content-section friend-requests-panel mat-elevation-z0" hideToggle [expanded]="expanded()" (opened)="expanded.set(true)" (closed)="expanded.set(false)">
  <mat-expansion-panel-header class="friend-requests-panel-header" collapsedHeight="auto" expandedHeight="auto">
    <div class="panel-header-content">
      <div class="panel-header-row">
        <div class="panel-header-title">
          <mat-icon>group</mat-icon>
          <div class="panel-title-text-block">
            <span class="panel-title-text">{{ 'organizationAdmin.friendRequests.title' | transloco }}</span>
            <span class="panel-title-meta">
              {{ 'organizationAdmin.friendRequests.metaOpen' | transloco: { count: incomingRequests().length } }}
              &middot;
              {{ 'organizationAdmin.friendRequests.metaConnections' | transloco: { count: connectedOrganizations().length } }}
            </span>
          </div>
        </div>
        <div class="panel-header-right">
          <div class="org-code-chip" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <div>
              <span class="org-code-label">{{ 'friendRequests.addInviteDialog.organizationCode' | transloco }}</span>
              <strong>{{ organizationCode() }}</strong>
            </div>
            <button
              mat-icon-button
              type="button"
              [cdkCopyToClipboard]="organizationCode()"
              [matTooltip]="'friendRequests.addInviteDialog.copyTooltip' | transloco"
              [attr.aria-label]="'friendRequests.addInviteDialog.copyTooltip' | transloco">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <mat-icon class="panel-chevron">{{ expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
      </div>
    </div>
  </mat-expansion-panel-header>

  <div class="invite-section">
    <p class="friend-requests-hint">{{ 'friendRequests.addInviteDialog.instructions.shareCode' | transloco }}</p>

    <span class="invite-send-label">{{ 'friendRequests.addInviteDialog.enterOrganizationCode' | transloco }}</span>
    <div class="invite-send-row">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <input
          matInput
          [formControl]="inviteCodeControl"
          [attr.aria-label]="'friendRequests.addInviteDialog.enterOrganizationCode' | transloco"
          placeholder="0000-0000-0000-0000"
          (keyup.enter)="sendFriendRequest()" />
      </mat-form-field>
      <button mat-flat-button color="primary" type="button" [disabled]="!canSendInvite()" (click)="sendFriendRequest()">
        <mat-icon>send</mat-icon>
        {{ 'friendRequests.addInviteDialog.sendRequestButton' | transloco }}
      </button>
    </div>
  </div>

  <div class="friend-requests-list">
    @if (loadFailed()) {
      <p class="empty-text">{{ 'errors.serverCommunicationError' | transloco }}</p>
    } @else if (isEmpty()) {
      <p class="empty-text">{{ 'organizationAdmin.friendRequests.emptyConnected' | transloco }}</p>
    }

    @for (request of incomingRequests(); track request.id) {
      <div class="friend-request-row">
        <div class="friend-request-name-block">
          <span class="friend-request-name">{{ request.senderOrganizationName }}</span>
        </div>
        <span class="status-chip status-pending">
          <mat-icon>incomplete_circle</mat-icon>
          {{ 'organizationAdmin.friendRequests.sections.incoming' | transloco }}
        </span>
        <div class="friend-request-actions">
          <button mat-flat-button color="primary" type="button" [disabled]="isRequestProcessing(request.id)" (click)="acceptRequest(request)">
            <mat-icon>check</mat-icon>
            {{ 'friendRequests.manageDialog.acceptButton' | transloco }}
          </button>
          <button mat-button color="primary" type="button" [disabled]="isRequestProcessing(request.id)" (click)="rejectRequest(request)">
            <mat-icon>close</mat-icon>
            {{ 'friendRequests.manageDialog.rejectButton' | transloco }}
          </button>
        </div>
      </div>
    }

    @for (request of outgoingRequests(); track request.id) {
      <div class="friend-request-row">
        <div class="friend-request-name-block">
          <span class="friend-request-name">{{ request.receiverOrganizationName }}</span>
        </div>
        <span class="status-chip status-sent">
          <mat-icon>pending</mat-icon>
          {{ 'organizationAdmin.friendRequests.sections.sent' | transloco }}
        </span>
        <div class="friend-request-actions">
          <button mat-button color="primary" type="button" [disabled]="isRequestProcessing(request.id)" (click)="rejectRequest(request)">
            <mat-icon>close</mat-icon>
            {{ 'organizationAdmin.friendRequests.withdrawButton' | transloco }}
          </button>
        </div>
      </div>
    }

    @for (org of connectedOrganizations(); track org.id) {
      <div class="friend-request-row">
        <div class="friend-request-name-block">
          <span class="friend-request-name">{{ org.name }}</span>
          @if (org.connectedSince) {
            <span class="friend-request-meta">
              {{ 'organizationAdmin.friendRequests.connectedSince' | transloco }} {{ org.connectedSince | date: 'shortDate' }}
            </span>
          }
        </div>
        <span class="status-chip status-connected">
          <mat-icon>circle</mat-icon>
          {{ 'organizationAdmin.friendRequests.sections.connected' | transloco }}
        </span>
        <div class="friend-request-actions">
          <button mat-button color="primary" type="button" (click)="unfriendOrganization(org)">
            <mat-icon>link_off</mat-icon>
            {{ 'organizationAdmin.friendRequests.disconnectButton' | transloco }}
          </button>
        </div>
      </div>
    }
  </div>

</mat-expansion-panel>
